module.exports = __webpack_public_path__ + "static/media/deskLogoNew.ff04857c.png";